export default __webpack_public_path__ + "static/icon-18-1-d93a8673f81394085ea838f6870716a6.png";